import { useEffect, useState } from "react";

import type { MachineFaultDisplay } from "@/schemas";
import { useErrorsAndWarnings } from "@/hooks/use-errors-and-warnings";

import { ErrorsAndWarningsModalTemplate } from "./errors-and-warnings-modal.template";

export type { MachineFaultDisplay };

export interface ErrorsAndWarningsModalProps {
	readonly faults?: MachineFaultDisplay[];
}

export const ErrorsAndWarningsModal = ({ faults }: ErrorsAndWarningsModalProps) => {
	const { isOpen, openModal, closeModal, faults: contextFaults } = useErrorsAndWarnings();
	const [currentIndex, setCurrentIndex] = useState(0);
	const displayFaults = faults ?? contextFaults;

	useEffect(() => {
		if (displayFaults.length === 0) {
			closeModal();
			setCurrentIndex(0);
			return;
		}

		if (currentIndex >= displayFaults.length) {
			setCurrentIndex(0);
		}
	}, [closeModal, currentIndex, displayFaults]);

	const handleClose = () => {
		closeModal();
		setCurrentIndex(0);
	};

	const showPrevious = () => {
		setCurrentIndex((index) => (index === 0 ? displayFaults.length - 1 : index - 1));
	};

	const showNext = () => {
		setCurrentIndex((index) => (index + 1) % displayFaults.length);
	};

	return (
		<ErrorsAndWarningsModalTemplate
			faults={displayFaults}
			open={isOpen}
			currentIndex={currentIndex}
			onOpen={openModal}
			onClose={handleClose}
			onPrevious={showPrevious}
			onNext={showNext}
		/>
	);
};
